import type { ListProps, OrderDirection } from "~/common/functions/listProps";
import { OrderBy } from "~/common/types";

type ListQueryArguments = {
  limit: number;
  offset: number;
  order_by: Record<string, OrderBy>;
};

export const HasuraGraphQLQueryMapper = {
  list: {
    toQueryArgs: (props: ListProps): ListQueryArguments => {
      const { page, rowsPerPage, sortOrder } = props;

      return {
        limit: rowsPerPage,
        offset: page * rowsPerPage,
        // if you want to use nested fields(ex: `user.role.name`), please override the `order_by` key on the client side.
        // eslint-disable-next-line camelcase
        order_by: {
          [sortOrder.name]: HasuraGraphQLQueryMapper.direction.toQueryArgs(sortOrder.direction),
        },
      };
    },
  },
  direction: {
    toQueryArgs: (direction: OrderDirection): OrderBy => {
      switch (direction) {
        case "asc":
          return OrderBy.Asc;
        case "desc":
          return OrderBy.Desc;
        default:
          throw new Error(`Invalid direction string: ${direction}`);
      }
    },
  },
};
